<template>
    <div v-if="canShow('经络风险评估') && info && jingluoList.length > 0">
        <!-- 打印模式 -->
        <template v-if="isPrint">
            <div class="face-analysis-title">经络风险评估</div>
            <div class="dotted-line"></div>
            <div class="jl-print-chart" v-if="chartImage">
                <img :src="chartImage" />
            </div>
            <div v-for="(item, index) in jingluoDescList" :key="'jl-print-' + index">
                <div class="jl-print-title">【{{ item.sysName }}（{{ item.sysLevelDesc }}）】</div>
                <div class="jl-print-desc">{{ item.sysDesc }}</div>
            </div>
        </template>

        <!-- 正常模式 -->
        <template v-else>
            <div class="tips"></div>
            <div class="sick-box">
                <div class="risk">经络风险评估</div>
            </div>

            <div class="assessment">
                <div class="new-title">【 经络状态评估 】</div>
                <div class="chart-container chart-max">
                    <div id="jingluoChart" class="jingluo-chart"></div>
                </div>
                <div class="table-mark" v-if="jingluoDescList.length>0">
                    <table class="newre-table jingluo-table">
                        <thead>
                            <tr>
                                <th style="width: 30%;">经络</th>
                                <th style="width: 70%;">风险评估说明</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in jingluoDescList" :key="'jl-' + index">
                                <td class="bold-text">{{ item.sysName }}({{ item.sysLevelDesc }})</td>
                                <td class="left-align-text">{{ item.sysDesc }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { moduleMixin } from '../helpers';
import { pillar } from '../chart';
import { mapState } from 'vuex';

export default {
    name: 'ReportJingluoRisk',
    mixins: [moduleMixin],
    data() {
        return {
            chartImage: ''
        };
    },
    computed: {
        ...mapState('report', ['info', 'page']),
        jingluoList() {
            const info = this.info || {};
            return Array.isArray(info.jingluo) ? info.jingluo : [];
        },
        jingluoDescList() {
            return this.jingluoList.filter(item => !!item.sysDesc);
        }
    },
    mounted() {
        if (this.isPrint) {
            this.$nextTick(() => {
                this.captureChart();
            });
        }
    },
    watch: {
        page: {
            handler() {
                if (!this.isPrint && this.canShow('经络风险评估')) {
                    this.$nextTick(() => {
                        this.initChart();
                    });
                }
            },
            immediate: true
        }
    },
    methods: {
        initChart() {
            const dom = document.getElementById('jingluoChart');
            if (!dom) return;
            const list = this.jingluoList;
            const names = list.map(item => item.sysName.split('').join('\n'));
            const data = list.map(item => item.sysScore);
            pillar('jingluoChart', names, data);
        },
        captureChart() {
            // 用 visibility hidden 而不是 left -9999px，确保 echarts 能计算尺寸
            const container = document.createElement('div');
            container.style.width = '750px';
            container.style.height = '500px';
            container.style.position = 'fixed';
            container.style.top = '0';
            container.style.left = '0';
            container.style.visibility = 'hidden';
            container.style.zIndex = '-1';
            container.id = 'jingluoChartPrint';
            document.body.appendChild(container);

            const list = this.jingluoList;
            const names = list.map(item => item.sysName.split('').join('\n'));
            const data = list.map(item => item.sysScore);
            const chart = pillar('jingluoChartPrint', names, data);

            if (chart) {
                // echarts 异步渲染，延迟后导出
                setTimeout(() => {
                    this.chartImage = chart.getDataURL({
                        type: 'png',
                        pixelRatio: 2,
                        backgroundColor: '#fff'
                    });
                    chart.dispose();
                    document.body.removeChild(container);
                }, 1200);
            } else {
                document.body.removeChild(container);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import './JingluoRisk.scss';
</style>
